import { loading } from '@/common/loading'
import { getWarnPageList, knowWarn,} from '@/api/baseMsg'
import { Toast } from 'vant'

export default {
    name: "provincialWarningManage",
    data() {
        return {
            btnFlag: false,
            isPlain: this.$route.query.isPlain == undefined ? true : Boolean(this.$route.query.isPlain),
            // isLoading: false,
            // 期号范围
            option1: [],
            option2: [],
            selectNum: 0,//选中页签
            startTime: '',
            endTime: '',
            List: [],//信息数组
            active2: 0,
            sum: {
                knowAll: '',
                finishKnow: '',
                unKnow: '',
                warnMessage: ''
            },
            startIssue: "",//开始期号
            endIssue: "",//结束期号
            showI1: false,//开始期号弹窗展示
            showI2: false,//结束期号弹窗展示
            currentDate: new Date(new Date().setDate(new Date().getDate() - 30)),//开始日期
            currentDate2: new Date(),//结束日期
            incomePayData: {
                currentPage: 1, //请求第几页
                pageSize: 999, //每页请求的数量
            },
            listTwo: [], //用于上拉加载时将数据合并
            total: 0, //总页数]
            loading: false,
            finished: false,
        }
    },
    created() {
        this.initTime()
        this.init();
    },
    mounted() {
        window.addEventListener('scroll', this.scrollToTop);
    },
    destroyed() {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
        //上拉加载
        onLoad() {
            this.incomePayData.currentPage++; //加载时页码递增
            getWarnPageList({
                startTime: this.startIssue,
                endTime: this.endIssue,
                ...this.incomePayData
            }).then(res => {
                if (res.code == 200) {
                    this.listTwo = res.data.data.list; //将接口返回赋值data定义的数组
                    this.total = res.data.data.total; //将接口返回的总数据条数赋值data中定义的total
                    this.listTwo.forEach(item => { //循环返回的数据并将数据添加到list中
                        this.List.push(item)
                    })
                    // 加载状态结束 状态更新为false
                    this.loading = false;
                    if (this.List.length >= this.total) { //将返回数据长度与总条数进行比较控制加载不加载的状态
                        this.finished = true;
                    }
                }
            })
        },
        init() {
            loading(true);
            this.getHandleList();
        },
        //置顶图标
        backTop() {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
        scrollToTop() {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            that.btnFlag = that.scrollTop > 130;
            // that.isBarNav = that.scrollTop > 10;
        },
        onClickLeft() {
            this.$router.push({
                path: '/',
            });
        },
        search() {
            loading(true);
            this.incomePayData.currentPage = 1
            this.getHandleList()
        },
        //获取待处理事项
        getHandleList() {
            getWarnPageList({
                startTime: this.startIssue,
                endTime: this.endIssue,
                ...this.incomePayData
            }).then(res => {
                if(res.code == 200) {
                    this.List = res.data.data.list;
                    this.sum = res.data.warnCount
                    this.total = res.data.data.total
                    if (this.List.length >= this.total) { //将返回数据长度与总条数进行比较控制加载不加载的状态
                        this.finished = true;
                    }
                }
                loading(false)
            })
        },
        //发布预警
        startWarn(warnDataId) {
            knowWarn({
                warnDataId: warnDataId,
            }).then(res => {
                if (res.code == 200) {
                    Toast.success(res.message);
                    setTimeout(() => {
                        loading(true)
                        this.getHandleList();
                    }, 1500);
                } else {
                    Toast.fail(res.message);
                }
            })
        },
        // 发布预警
        fabu(warnDataId) {
            this.$dialog.confirm({
                message: '您确定知晓此条预警吗?'
            }).then(() => {
                this.startWarn(warnDataId);
            }).catch(() => { })
        },
        showStartI() {
            // 展示开始期号弹窗
            this.showI1 = true;
        },
        showEndI() {
            // 展示结束期号弹窗
            this.showI2 = true;
        },
        onConfirm1() {
            // 开始期号弹窗确认
            let nowDate = this.currentDate;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` };
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` };
            this.startIssue = `${year}-${month}-${day}`;
            this.showI1 = false;
        },
        onCancel1() {
            // 开始期号弹窗关闭
            this.showI1 = false;
        },
        onConfirm2() {
            // 结束期号弹窗确认
            let nowDate = this.currentDate2;
            let year= nowDate.getFullYear();
            let month = nowDate.getMonth() + 1; if (month >= 1 && month <= 9) { month = `0${month}` };
            let day = nowDate.getDate();  if (day >= 1 && day <= 9) { day = `0${day}` };
            this.endIssue = `${year}-${month}-${day}`;
            this.showI2 = false;
        },
        onCancel2() {
            // 结束期号弹窗关闭
            this.showI2 = false;
        },
        initTime() {
            //初始化显示时间函数
            let sD,
              sM,
              sY,
              eD,
              eM,
              eY = "";
            let today = new Date().getTime();
            eD = new Date().getDate();
            if (eD >= 1 && eD <= 9) { eD = `0${eD}` };
            eM = new Date().getMonth() + 1;
            if (eM >= 1 && eM <= 9) { eM = `0${eM}` };          
            eY = new Date().getFullYear();
            this.endIssue = eY + "-" + eM + "-" + eD;
            // sD = new Date(today - 172800000).getDate();
            // sM = new Date(today - 172800000).getMonth() + 1;
            // sY = new Date(today - 172800000).getFullYear();
            sD = new Date(new Date().setDate(new Date().getDate() - 6 * 30)).getDate()
            if (sD >= 1 && sD <= 9) { sD = `0${sD}` };
			sM = new Date(new Date().setDate(new Date().getDate() - 6 * 30)).getMonth() + 1
            if (sM >= 1 && sM <= 9) { sM = `0${sM}` };
			sY = new Date(new Date().setDate(new Date().getDate() - 6 *30)).getFullYear()
            this.startIssue = sY + "-" + sM + "-" + sD;
            this.currentDate = this.convertDateFromString(this.startIssue);
            this.currentDate2 = this.convertDateFromString(this.endIssue);
        },
        formatter(type, value) {
            if (type === 'year') {
                return `${value}年`;
            } else if (type === 'month') {
                return `${value}月`
            } else if (type === 'day') {
                return `${value}日`
            }
            return value;
        },
        convertDateFromString(dateString) {
            if (dateString) {
                var date = new Date(dateString.replace(/-/, "/"))
                return date;
            }
        },
    }
}